import React, { SVGProps } from "react";

export default function SupChain(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2 16.7245V16.3117C2.11679 16.3251 2.23279 16.347 2.34698 16.3775L2 16.7245Z" fill="currentColor" />
      <path d="M2 17.8392V17.2902L3.98822 15.3019L5.1196 16.4333L3.5529 18H2.16081L2 17.8392Z" fill="currentColor" />
      <path d="M18 2.16081V3.5529L16.4333 5.1196L15.3019 3.98823L17.2902 2H17.8392L18 2.16081Z" fill="currentColor" />
      <path d="M16.7245 2L16.3775 2.34698C16.347 2.23279 16.3251 2.11679 16.3117 2H16.7245Z" fill="currentColor" />
      <path
        d="M13.5491 8.56952C14.3498 8.78334 15.2395 8.57617 15.8676 7.94802L16.999 6.81665C17.6271 6.1885 17.8343 5.29878 17.6205 4.4981L16.8988 5.21977C16.8754 5.59524 16.7202 5.96404 16.4333 6.25097L15.3019 7.38234C15.015 7.66927 14.6462 7.82444 14.2707 7.84785L13.5491 8.56952Z"
        fill="currentColor"
      />
      <path
        d="M9.02359 13.095C9.82427 13.3088 10.714 13.1017 11.3421 12.4735L12.4735 11.3421C13.1017 10.714 13.3088 9.82427 13.095 9.02359L12.3733 9.74526C12.3499 10.1207 12.1947 10.4895 11.9078 10.7765L10.7765 11.9078C10.4895 12.1948 10.1207 12.3499 9.74526 12.3733L9.02359 13.095Z"
        fill="currentColor"
      />
      <path
        d="M4.4981 17.6205C5.29878 17.8343 6.1885 17.6271 6.81665 16.999L7.94802 15.8676C8.57617 15.2395 8.78334 14.3498 8.56952 13.5491L7.84785 14.2707C7.82444 14.6462 7.66927 15.015 7.38234 15.3019L6.25097 16.4333C5.96404 16.7202 5.59524 16.8754 5.21977 16.8988L4.4981 17.6205Z"
        fill="currentColor"
      />
      <path
        d="M13.6049 3.42254C14.233 2.79439 15.1227 2.58723 15.9234 2.80105L15.2018 3.52272C14.8263 3.54613 14.4575 3.7013 14.1706 3.98823L13.0392 5.1196C12.7523 5.40653 12.5971 5.77532 12.5737 6.15079L11.852 6.87246C11.6382 6.07178 11.8454 5.18206 12.4735 4.55391L13.6049 3.42254Z"
        fill="currentColor"
      />
      <path
        d="M9.07939 7.94802C9.70754 7.31987 10.5973 7.11271 11.3979 7.32653L10.6763 8.0482C10.3008 8.07161 9.93201 8.22678 9.64508 8.51371L8.51371 9.64508C8.22678 9.93201 8.07161 10.3008 8.0482 10.6763L7.32653 11.3979C7.11271 10.5973 7.31987 9.70754 7.94802 9.07939L9.07939 7.94802Z"
        fill="currentColor"
      />
      <path
        d="M4.55391 12.4735C5.18206 11.8454 6.07178 11.6382 6.87246 11.852L6.15079 12.5737C5.77532 12.5971 5.40652 12.7523 5.1196 13.0392L3.98822 14.1706C3.7013 14.4575 3.54613 14.8263 3.52272 15.2018L2.80105 15.9234C2.58722 15.1227 2.79439 14.233 3.42254 13.6049L4.55391 12.4735Z"
        fill="currentColor"
      />
      <path d="M7.38234 14.1706L6.25097 13.0392L8.51371 10.7765L9.64508 11.9078L7.38234 14.1706Z" fill="currentColor" />
      <path d="M10.7765 8.51371L13.0392 6.25097L14.1706 7.38234L11.9078 9.64508L10.7765 8.51371Z" fill="currentColor" />
    </svg>
  );
}
